import {
  SIX_MONTHS_FINANCING_MODAL_ID,
  TWELVE_MONTHS_FINANCING_MODAL_ID,
  SIX_MONTHS
} from './constants'

export const injectDynamicVerbiage = ({
  paymentOptionsBannerTemplate,
  estimatedTotal,
  monthlyPaymentAmount,
  paymentOption,
  threePaymentsValue
}) => paymentOptionsBannerTemplate
  .replace(/ESTIMATEDTOTAL/g, String(estimatedTotal))
  .replace(/PAYMENTAMOUNT/g, String(monthlyPaymentAmount))
  .replace(/PAYMENTOPTION/g, paymentOption)
  .replace(/THREEPAYMENTS/g, threePaymentsValue)
  .replace(/MODALOPTION/g, paymentOption === SIX_MONTHS ?
    SIX_MONTHS_FINANCING_MODAL_ID :
    TWELVE_MONTHS_FINANCING_MODAL_ID)
